import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { RecyclingCompanyService } from 'services/recycling-company-service';

@autoinject
export class RecyclingCompanyList {
  private tableData: Array<Models.RecyclingCompany>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private recyclingCompanyService: RecyclingCompanyService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('recyclingCompanyListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.recyclingCompanyService
      .getAll('?$orderby=Name')
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('recycling-company-detail', { Id: id });
  }
}
